/* Load Modules */
import React, { Component } from "react";

/* Load Styles */
import "./redirect.component.scss";

export interface RedirectPageProps {
    url: string;
}
export default class RedirectPage extends Component<RedirectPageProps, {}> {
    render() {
        return (
            <div id="redirect-page">
                <h1>Remote Access</h1>
                <h2>
                    This feature is not incorporated in Wave, you will be taken
                    to a website outside of this ecosystem.
                    <br />
                    <br />
                    To be redirected to the Remote Access website please click{" "}
                    <a href={this.props.url} target={"_blank"}>
                        here
                    </a>{" "}
                    .
                </h2>
            </div>
        );
    }
}
